import { useNavigate } from "react-router-dom";
import { RoutePaths } from "../../RoutePaths";
import { usePlaylistMutations } from "../graphql/usePlaylistMutations";
import { PlaylistRoutePaths } from "../PlaylistRoutePaths";
import { forgetRecentPreviews } from "./RecentPreviews";

/**
 * Saves a preview as a private copy with a new id and opens it. The id of the preview stays reserved for the real
 * playlist, which is loaded once online.
 */
export function useSavePreviewAsOwnPlaylist() {
  const navigate = useNavigate();
  const playlistMutations = usePlaylistMutations();

  return (preview: { id: string; songIds: readonly string[] }) => {
    const newIdentifier = playlistMutations.createPlaylist({
      crewId: undefined,
      songEntryIds: preview.songIds,
    });
    forgetRecentPreviews([preview.id]);
    // add some browser history to be able to use the back buttons as expected
    navigate(RoutePaths.HOME);
    navigate(PlaylistRoutePaths.toCarousel(newIdentifier));
  };
}
